let state = {
  operators: [],
  regions: [],
  plans: [],
  categories: [],
  filteredPlans: [],
  planCategories: [],
  amount: '',
  operator: '',
  region: '',
  recharge_account_id: '',
  valid_recharge_account_id: false,
  selectedPlan: '',
  selectedPlanDescription: '',
  selectedCategory: 'All'
}
export default state



// WEBPACK FOOTER //
// ./src/store/recharge/state.js